import { getPbgidName, getPbgidTypes, isMilitaryUnit, toIconUrl } from './pbgidIcons'
import { DEFAULT_LANG } from './i18n'

// Military typed units that still are not part of the unit composition
const EXCLUDED_TYPES = ['naval_transport', 'rus_auxiliary']

/** "man_at_arms" -> "Man At Arms" */
function prettyName(key) {
	return key
		.split('_')
		.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
		.join(' ')
}

/** "races/english/units/man_at_arms_2.png" -> { key: "man_at_arms", age: 2 } */
function parseIcon(icon) {
	const last = String(icon ?? '')
		.toLowerCase()
		.split('/')
		.pop()
		.replace(/\.png$/, '')
	const age = last.match(/_(\d)$/)?.[1]

	return { key: last.replace(/_\d$/, ''), age: age ? Number(age) : 1 }
}

function lookupUnit(item, pbgidIcons, lang) {
	const entry = pbgidIcons?.[item.pbgid]
	if (!entry || !isMilitaryUnit(pbgidIcons, item.pbgid)) return null
	if (getPbgidTypes(pbgidIcons, item.pbgid).some((type) => EXCLUDED_TYPES.includes(type))) return null

	const { key, age } = parseIcon(entry.icon)
	return { key, age, name: getPbgidName(pbgidIcons, item.pbgid, lang) ?? prettyName(key), icon: toIconUrl(entry.icon) }
}

/**
 * Total military units produced during the game, most produced first.
 * Age variations are merged (archer_2 + archer_3 = archer) and the icon of the
 * highest age variation the player actually made is kept, names come from screen_name.
 * Returns [{ key, name, count, icon }]
 */
export function convertUnitComp(player, pbgidIcons, lang = DEFAULT_LANG) {
	const totals = new Map()

	for (const item of player?.buildOrder ?? []) {
		const unit = lookupUnit(item, pbgidIcons, lang)
		if (!unit) continue

		const produced = (item.finished?.length ?? 0) + (item.constructed?.length ?? 0) + (item.unknown?.['14']?.length ?? 0)
		if (!produced) continue

		const entry = totals.get(unit.key) ?? { key: unit.key, name: unit.name, count: 0, icon: unit.icon, age: unit.age }
		entry.count += produced
		if (unit.age >= entry.age) {
			entry.icon = unit.icon
			entry.name = unit.name
			entry.age = unit.age
		}
		totals.set(unit.key, entry)
	}

	return [...totals.values()].sort((a, b) => b.count - a.count || a.name.localeCompare(b.name)).map(({ key, name, count, icon }) => ({ key, name, count, icon }))
}
